export type ViewMode = 'list' | 'card';

export interface ListViewPreferences {
  showThumbnails: boolean;
  showTags: boolean;
}

export interface DateRange {
  start: string | null;
  end: string | null;
}

/** localStorage key for persisting view mode preference */
export const VIEW_MODE_STORAGE_KEY = 'notego_view_mode';

/** localStorage key for persisting list view preferences */
export const LIST_VIEW_PREFS_STORAGE_KEY = 'notego_list_view_prefs';
